import { ExperienceTemplateRenderer, TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

interface UitkComponentTemplateComponent extends TemplateComponent {
  config: {
    type: string;
  };
}

export interface UitkComponentProps extends TemplateComponentProps {
  templateComponent: UitkComponentTemplateComponent;
}

export const UitkComponent: React.FC<UitkComponentProps> = ({ templateComponent }) => {
  const {
    children,
    config: { type, ...props },
  } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  const templateRenderer = <ExperienceTemplateRenderer templateComponents={children} />;

  switch (type) {
    case 'UitkLayoutFlex':
      return <UitkLayoutFlex {...props}>{templateRenderer}</UitkLayoutFlex>;
    case 'UitkLayoutFlexItem':
      return (
        <UitkLayoutFlexItem {...props}>
          <div>{templateRenderer}</div>
        </UitkLayoutFlexItem>
      );
    case 'UitkLayoutGrid':
      return <UitkLayoutGrid {...props}>{templateRenderer}</UitkLayoutGrid>;
    case 'UitkLayoutGridItem':
      return (
        <UitkLayoutGridItem {...props}>
          <div>{templateRenderer}</div>
        </UitkLayoutGridItem>
      );
    default:
      return null;
  }
};
